import script from "./SubscriptionWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionWidget.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionWidget.vue?vue&type=style&index=0&id=36b6e5be&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b6e5be"]])

export default __exports__